const SPANISH_TEXT = {
    'Syncro module (optional)': 'Módulo de Syncro (opcional)',
    'Select a sidebar module': 'Seleccionar un módulo del menú lateral',
    'No module selected': 'Sin módulo seleccionado',

    '🧾 Submit a Request': '🧾 Enviar una solicitud',
    '👥 People & HR': '👥 Personas y RRHH',
    '🛠️ Equipment & Maintenance Requests': '🛠️ Equipos y Mantenimiento (Solicitudes)',
    '📦 Inventory & Product Portfolio': '📦 Inventario y Portafolio de Productos',
    '🚚 Logistics & Operations': '🚚 Logística y Operaciones',
    '🧾 Branding & Merchandising': '🧾 Marca y Mercadeo',
    'Branding & Merchandising': 'Marca y Mercadeo',
    '🏢 Locations & Partnerships': '🏢 Ubicaciones y Alianzas',
    '🏗️ Infrastructure & Equipment (Non-machine)': '🏗️ Infraestructura y Equipamiento (No relacionado a máquinas)',
    '💻 Syncro — Support & Development': '💻 Syncro — Soporte y Desarrollo',
    'Request preventive maintenance': 'Solicitar mantenimiento preventivo',
    'Request spare parts': 'Solicitar repuestos',
    'Machine update (cashless, screen, etc.)': 'Actualización de máquina (cashless, pantalla, etc.)',
    'Replace machine': 'Reemplazar máquina',
    'Install new machine': 'Instalar nueva máquina',
    'Relocate machine': 'Reubicar máquina',
    'Retire / decommission machine': 'Retirar / dar de baja máquina',
    'Cleaning / refurbishment request': 'Solicitud de limpieza / reacondicionamiento',
    'Change product assortment': 'Cambiar surtido de productos',
    'Add new SKU(s)': 'Agregar nuevos SKU(s)',
    'Remove low-performing products': 'Eliminar productos de bajo rendimiento',
    'Price changes': 'Cambios de precios',
    'Report inventory shortages': 'Reportar faltantes de inventario',
    'Route optimization': 'Optimización de rutas',
    'Change delivery frequency': 'Cambiar frecuencia de entregas',
    'Emergency restocking': 'Reabastecimiento de emergencia',
    'Warehouse replenishment request': 'Solicitud de reposición de almacén',
    'Delivery issue (late / incomplete)': 'Problema con entrega (tarde / incompleta)',
    'New location setup (logistics configuration)': 'Alta de nueva ubicación (configuración logística)',
    'Request new machine wrap / vinyl': 'Solicitar nuevo vinilado / wrapping de máquina',
    'Update branding / decals': 'Actualizar branding / calcomanías',
    'Update digital screen content': 'Actualización de contenido en pantallas digitales',
    'Request new location': 'Solicitar nueva ubicación',
    'Remove machine from a location': 'Retirar máquina de una ubicación',
    'Report location issue (low traffic, access, etc.)': 'Reportar problema con la ubicación (bajo tráfico, acceso, etc.)',
    'Partnership opportunity': 'Oportunidad de alianza',
    'Request forklift / warehouse equipment': 'Solicitar montacargas / equipo de almacén',
    'Request operating supplies (gloves, cleaning materials, etc.)': 'Solicitar insumos operativos (guantes, materiales de limpieza, etc.)',
    'Security improvements (cameras, locks, anti-theft systems)': 'Mejoras de seguridad (cámaras, cerraduras, sistemas anti-robo)',
    'Report a Syncro error': 'Reportar un error de Syncro',
    'Request a Syncro improvement': 'Solicitar una mejora de Syncro',
    'Request a new Syncro feature': 'Solicitar una nueva función de Syncro',
    'Syncro access or permissions': 'Acceso o permisos de Syncro',
    'Incorrect Syncro data or reports': 'Datos o reportes incorrectos de Syncro',
    'Syncro notifications or integrations': 'Notificaciones o integraciones de Syncro',
    'Help using Syncro': 'Ayuda para usar Syncro',
    'Other Syncro issue': 'Otro asunto de Syncro',
    'Report a concern (confidential option)': 'Reportar un problema (opción confidencial)',
    'Unprofessional behavior': 'Comportamiento no profesional',
    'Policy violation': 'Violación de políticas',
    'Staff-related safety issue': 'Problema de seguridad relacionado con el personal',
    'Harassment / misconduct': 'Acoso / mala conducta',
    'Recognize strong performance': 'Reconocer buen desempeño',
    'Exceptional service (above and beyond)': 'Servicio excepcional (más allá de lo esperado)',
    'Excellent customer / location handling': 'Excelente manejo de cliente / ubicación',
    'Team collaboration': 'Colaboración en equipo',
    'Preventive Maintenance': 'Mantenimiento preventivo',
    'Parts Inventory': 'Inventario de repuestos',
    'Machine Upgrades': 'Actualización de máquinas',
    'Machine Lifecycle': 'Ciclo de vida de máquinas',
    'Machine Installation': 'Instalación de máquinas',
    'Machine Relocation': 'Reubicación de máquinas',
    'Machine Refurbishment': 'Reacondicionamiento de máquinas',
    'Merchandising': 'Mercadeo',
    'Pricing': 'Precios',
    'Warehouse Inventory': 'Inventario de almacén',
    'Route Operations': 'Operaciones de rutas',
    'Delivery Resolution': 'Resolución de entregas',
    'Location Setup': 'Configuración de ubicación',
    'Branding': 'Marca',
    'Digital Content': 'Contenido digital',
    'Location Growth': 'Expansión de ubicaciones',
    'Location Review': 'Revisión de ubicaciones',
    'Partnerships': 'Alianzas',
    'Warehouse Equipment': 'Equipos de almacén',
    'Warehouse Supplies': 'Insumos de almacén',
    'Infrastructure & Equipment': 'Infraestructura y Equipamiento',
    'Syncro Development': 'Desarrollo de Syncro',
    'Syncro Product': 'Producto Syncro',
    'Syncro Administration': 'Administración de Syncro',
    'Syncro Triage': 'Clasificación de Syncro',
    'People & HR': 'Personas y RRHH',
    'Operations & People': 'Operaciones y Personas',
    'Admin-only workspace for operational requests, internal people feedback, employee timelines, and future performance reviews.':
        'Espacio administrativo para solicitudes operativas, feedback interno del personal, historial de empleados y futuras evaluaciones de desempeño.',
    'New Request': 'Nueva Solicitud',
    'Open Requests': 'Solicitudes abiertas',
    'Open Feedback': 'Feedback abierto',
    'Employees With Alerts': 'Empleados con alertas',
    'Recognitions Logged': 'Reconocimientos registrados',
    'Requests': 'Solicitudes',
    'Operational Requests': 'Solicitudes operativas',
    'Admin-managed intake for vending operator requests.': 'Gestión administrativa de solicitudes de operadores de vending.',
    'Search requests': 'Buscar solicitudes',
    'Status': 'Estado',
    'Priority': 'Prioridad',
    'Category': 'Categoría',
    'Routing': 'Ruteo',
    'Clear Filters': 'Limpiar filtros',
    'All Categories': 'Todas las categorías',
    'Search routing settings': 'Buscar subcategoría, ruteo o responsable',
    'No open requests.': 'No hay solicitudes abiertas.',
    'Created': 'Creado',
    'Time Elapsed': 'Tiempo transcurrido',
    'Opened By': 'Abierto por',
    'Request': 'Solicitud',
    'Open': 'Abrir',
    'Closed Requests': 'Solicitudes cerradas',
    'Resolved requests with recorded close times.': 'Solicitudes resueltas con fecha de cierre registrada.',
    'No closed requests.': 'No hay solicitudes cerradas.',
    'Closed': 'Cerrado',
    'People Feedback': 'Feedback del personal',
    'Confidential Feedback': 'Feedback confidencial',
    'Hidden from employees. Visible only to admins.': 'Oculto para los empleados. Visible solo para administradores.',
    'Search feedback': 'Buscar feedback',
    'Type': 'Tipo',
    'Severity': 'Severidad',
    'Employee': 'Empleado',
    'No open feedback.': 'No hay feedback abierto.',
    'Feedback': 'Feedback',
    'Closed Feedback': 'Feedback cerrado',
    'Resolved confidential feedback with recorded close times.': 'Feedback confidencial resuelto con fecha de cierre registrada.',
    'No closed feedback.': 'No hay feedback cerrado.',
    'Employees': 'Empleados',
    'Employee Profiles': 'Perfiles de empleados',
    'Internal scorecards, escalation alerts, and full timeline per employee.': 'Indicadores internos, alertas de escalamiento e historial completo por empleado.',
    'Search employees': 'Buscar empleados',
    'Role': 'Rol',
    'Team': 'Equipo',
    'Showing Alerts Only': 'Mostrando solo alertas',
    'Show Escalations Only': 'Mostrar solo escalaciones',
    'No employee data available.': 'No hay datos de empleados disponibles.',
    'Email': 'Correo',
    'Score': 'Puntaje',
    'Recognitions': 'Reconocimientos',
    'Complaints': 'Quejas',
    'Assigned Requests': 'Solicitudes asignadas',
    'Alerts': 'Alertas',
    'Escalated': 'Escalado',
    'Normal': 'Normal',
    'Actions': 'Acciones',
    'Loading...': 'Cargando...',
    'View Profile': 'Ver perfil',
    'Performance Review': 'Evaluación de desempeño',
    'Coming Soon': 'Próximamente',
    'This section is reserved for future performance reviews that combine managerial evaluation with quantitative signals from operational reports.':
        'Esta sección queda reservada para futuras evaluaciones de desempeño que combinen evaluación gerencial con señales cuantitativas de reportes operativos.',
    'Settings': 'Configuración',
    'HR Routing Settings': 'Configuración de ruteo de Operaciones y Personas',
    'Configure one or more route owners per category and subcategory. New tickets inherit these owners automatically.':
        'Configura uno o más responsables por categoría y subcategoría. Los nuevos tickets heredarán estos responsables automáticamente.',
    'Request Routing': 'Ruteo de solicitudes',
    'Subcategory-level routing for operational requests.': 'Ruteo a nivel de subcategoría para solicitudes operativas.',
    'No request routing settings found.': 'No se encontraron configuraciones de ruteo para solicitudes.',
    'Subcategory': 'Subcategoría',
    'Route Owners': 'Responsables de ruta',
    'Updated By': 'Actualizado por',
    'Updated': 'Actualizado',
    'People & HR Routing': 'Ruteo de Personas y RRHH',
    'Feedback categories inherit route owners by feedback type and category.':
        'Las categorías de feedback heredan responsables de ruta según el tipo y la categoría.',
    'No feedback routing settings found.': 'No se encontraron configuraciones de ruteo para feedback.',
    'Feedback Type': 'Tipo de feedback',
    'Select route owners': 'Seleccionar responsables',
    'What would you like to do?': '¿Qué te gustaría hacer?',
    'Select category': 'Seleccionar categoría',
    'Select subcategory': 'Seleccionar subcategoría',
    'Machine': 'Máquina',
    'Optional machine': 'Máquina opcional',
    'Location': 'Ubicación',
    'Optional location': 'Ubicación opcional',
    'Routing Preview: ': 'Vista previa del ruteo: ',
    'Select category and subcategory': 'Selecciona categoría y subcategoría',
    'Select feedback type': 'Selecciona el tipo de feedback',
    'Select employee': 'Seleccionar empleado',
    'Select feedback category': 'Seleccionar categoría de feedback',
    'Confidential Submission': 'Envío confidencial',
    'Photos': 'Fotos',
    'Optional. Up to 5 photos. Max 500 KB each.': 'Opcional. Hasta 5 fotos. Máximo 500 KB cada una.',
    'Optional. Up to 10 photos. Max 500 KB each.': 'Opcional. Hasta 10 fotos. Máximo 500 KB cada una.',
    'Maximum 10 photos allowed.': 'Máximo 10 fotos permitidas.',
    'photo': 'foto',
    'photos': 'fotos',
    'added': 'agregada',
    'Description': 'Descripción',
    'Describe the request or feedback': 'Describe la solicitud o el feedback',
    'Describe what happened, what you expected, and the affected Syncro screen or module': 'Describe qué ocurrió, qué esperabas y la pantalla o módulo de Syncro afectado',
    'Cancel': 'Cancelar',
    'Saving...': 'Guardando...',
    'Save': 'Guardar',
    'Request Detail': 'Detalle de la solicitud',
    'Feedback Detail': 'Detalle del feedback',
    'Created By': 'Creado por',
    'Closed By': 'Cerrado por',
    'Closed At': 'Cerrado el',
    'Not applicable for recognition': 'No aplica para reconocimiento',
    'Requested For': 'Solicitado para',
    'Confidential': 'Confidencial',
    'Named Submission': 'Envío identificado',
    'No comments yet.': 'Aún no hay comentarios.',
    'Internal Comments': 'Comentarios internos',
    'comment': 'comentario',
    'comments': 'comentarios',
    'Add an internal comment': 'Agregar un comentario interno',
    'Add Comment': 'Agregar comentario',
    'View': 'Ver',
    'Mark Open': 'Marcar abierto',
    'Mark In Progress': 'Marcar en progreso',
    'Close Ticket': 'Cerrar ticket',
    'Alert': 'Alerta',
    '3+ complaints in 7 days': '3+ quejas en 7 días',
    'No active escalation': 'Sin escalación activa',
    'Timeline': 'Historial',
    'No timeline entries yet.': 'Aún no hay elementos en el historial.',
    'Date': 'Fecha',
    'Title': 'Título',
    'Assigned To': 'Responsable',
    'Select responsible': 'Seleccionar responsable',
    'No route owners configured': 'No hay responsables de ruta configurados',
    'Employee Profile': 'Perfil del empleado',
    'Complaint': 'Queja',
    'Recognition': 'Reconocimiento',
    'My Requests': 'Mis solicitudes',
    'Assigned to Me': 'Asignadas a mí',
    'Submit operational requests or feedback, and track your tickets.': 'Envía solicitudes operativas o feedback, y da seguimiento a tus tickets.',
    'You have not submitted any requests yet.': 'Aún no has enviado ninguna solicitud.',
    'No tickets assigned to you.': 'No tienes tickets asignados.',
    'Reassign Route Owners': 'Reasignar responsables',
    'Comments': 'Comentarios',
    'Add a comment': 'Agregar un comentario',
    'Remove': 'Eliminar',
    'Unnamed Machine': 'Máquina sin nombre',
    'Unknown Type': 'Tipo desconocido',
    'No location': 'Sin ubicación',
    'No ID': 'Sin ID',
    'Open Assigned': 'Asignados abiertos',
    'In Progress': 'En progreso',
    'Resolved This Week': 'Resueltos esta semana',
    'Newest First': 'Más recientes primero',
    'Oldest First': 'Más antiguos primero',
    'All Statuses': 'Todos los estados',
    'Resolved': 'Resuelto',
    'owners': 'responsables',
    'Low': 'Baja',
    'Medium': 'Media',
    'High': 'Alta',
    'Open': 'Abierto',
    'In Review': 'En revisión'
};

const TOKEN_TRANSLATIONS = {
    open: 'Abierto',
    resolved: 'Resuelto',
    complaint: 'Queja',
    recognition: 'Reconocimiento',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    'in progress': 'En progreso',
    'in review': 'En revisión',
    feedback: 'Feedback',
    request: 'Solicitud'
};

export const translateHrText = (value, language = 'es') => {
    if (language !== 'es') return value;
    return SPANISH_TEXT[value] || value;
};

export const translateHrToken = (value, language = 'es') => {
    const displayValue = String(value || '-').replace(/_/g, ' ');
    if (language !== 'es') return displayValue;
    return TOKEN_TRANSLATIONS[displayValue.toLowerCase()] || translateHrText(displayValue, language);
};
